import { render, staticRenderFns } from "./UserChannelVipLog.vue?vue&type=template&id=457830c9&"
import script from "./UserChannelVipLog.vue?vue&type=script&lang=js&"
export * from "./UserChannelVipLog.vue?vue&type=script&lang=js&"
import style0 from "./UserChannelVipLog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports